"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
exports.PanelStyled = styled.div `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 2em;
  align-items: stretch;
  justify-content: stretch;
  padding: 1em;
  border-width: 0.0625em;
  border-style: solid;
  border-color: ${design_system_1.theme.colors.marine[50]};
  border-radius: 1em;
  background-color: ${design_system_1.theme.colors.white};
  color: ${design_system_1.theme.colors.marine[100]};
}
`;
//# sourceMappingURL=Panel.styled.js.map